import { useState } from 'react';

import LoanAgreement from './LoanAgreement'
export default function AgreementPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="AgreementPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div><LoanAgreement/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
